var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWheelChair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 100,
    viewBox: "0 0 107 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 106,
    height: 100,
    rx: 50,
    fill: "#F7F8FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_74_2522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0203 77.7386C53.7464 77.7386 59.1989 72.286 59.1989 65.56C59.1989 58.8339 53.7464 53.3813 47.0203 53.3813C40.2942 53.3813 34.8417 58.8339 34.8417 65.56C34.8417 72.286 40.2942 77.7386 47.0203 77.7386Z",
    fill: "#BEBCFA",
    stroke: "#4540DB",
    strokeWidth: 1.68279,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2659 51.3908C53.3035 52.4788 53.4403 53.561 53.6746 54.6242C53.7491 54.9631 53.8332 55.2901 53.915 55.605L64.9229 55.5641C65.7223 55.6481 66.4919 55.9137 67.173 56.3406C68.4928 57.1892 69.0962 58.4802 69.464 59.4514C70.4256 61.901 71.8103 66.8821 73.1469 73.445C73.1968 74.1804 73.0343 74.9146 72.6789 75.5602C72.3235 76.2059 71.79 76.7359 71.142 77.087C70.3629 77.4687 69.4788 77.5794 68.6296 77.4018C67.7805 77.2241 67.0149 76.7682 66.4542 76.1062C65.2939 72.1236 64.1343 68.141 62.9756 64.1584C62.9156 63.9429 62.8033 63.7455 62.6487 63.5838C62.1006 63.0237 61.252 63.1992 61.175 63.216L50.8114 63.2953C49.8703 63.0836 49.006 62.616 48.3137 61.9443C47.4224 61.0569 46.8717 59.8842 46.7583 58.6316L43.2821 42.4287C43.1963 41.9394 43.2076 41.4379 43.3155 40.953C43.4235 40.468 43.6258 40.0091 43.9111 39.6024C44.1964 39.1957 44.559 38.8491 44.9783 38.5825C45.3975 38.3159 45.8651 38.1345 46.3544 38.0486C46.8438 37.9628 47.3452 37.9741 47.8302 38.082C48.3151 38.19 48.774 38.3924 49.1808 38.6776C49.5875 38.9629 49.934 39.3255 50.2006 39.7448C50.4672 40.164 50.6486 40.6316 50.7345 41.1209C51.1175 42.5249 51.4974 43.9296 51.874 45.3351H60.0476C60.6558 45.5223 61.194 45.8876 61.5926 46.3837C61.9912 46.8798 62.232 47.4841 62.2837 48.1184C62.3355 48.7527 62.1959 49.388 61.883 49.9421C61.5701 50.4963 61.0982 50.944 60.5284 51.2273L53.2659 51.3908Z",
    fill: "white",
    stroke: "#4540DB",
    strokeWidth: 1.68279,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4963 47.2414C48.3607 47.9303 48.4309 48.644 48.698 49.2933C48.9652 49.9427 49.4176 50.499 49.9988 50.8931C51.4268 51.8402 53.023 51.3739 53.2225 51.3089",
    stroke: "#4540DB",
    strokeWidth: 1.68279,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6353 36.5773C39.0584 42.2251 40.4912 47.8721 41.9336 53.5183",
    stroke: "#4540DB",
    strokeWidth: 1.68279,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8497 34.082C50.9684 34.082 53.4966 31.5538 53.4966 28.4351C53.4966 25.3163 50.9684 22.7881 47.8497 22.7881C44.7309 22.7881 42.2027 25.3163 42.2027 28.4351C42.2027 31.5538 44.7309 34.082 47.8497 34.082Z",
    fill: "white",
    stroke: "#4540DB",
    strokeWidth: 1.68279,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_74_2522"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 56.6332,
    fill: "white",
    transform: "translate(34 21.9468)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelChair);
export default __webpack_public_path__ + "static/media/WheelChair.5af6c42fd268066ac3d9442be2e3f247.svg";
export { ForwardRef as ReactComponent };